import React, { useEffect, useState } from 'react';

function Rajawaka({ onBackClick }) {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const [activeRoom, setActiveRoom] = useState(1);

    const rooms = [
        { id: 1, name: 'කාමර පිළිබඳ විස්තර' },
        { id: 2, name: 'පිහිටි ස්ථානය' },
        { id: 3, name: 'විමසීම් කළ හැකි දුරකථන අංකය' },
        { id: 4, name: 'Gallery' },
    ];

    const [activeRoomType, setActiveRoomType] = useState('A');

    const roomTypes = [
        { id: 'A', name: 'Type A' },
        { id: 'B', name: 'Type B' },
        { id: 'C', name: 'Type C' },
        { id: 'D', name: 'දේශන ශාලාව' },
    ];

    return (
        <div className="page-content rajawaka-page" style={{ maxWidth: '1100px', margin: '0 auto', padding: '40px 16px 120px' }}>
            <button
                className="back-button"
                onClick={() => onBackClick('home')}
                style={{
                    backgroundColor: '#0b6b2f',
                    color: 'white',
                    border: 'none',
                    padding: '8px 16px',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    fontSize: '14px',
                    marginBottom: '12px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '6px'
                }}
            >
                ←  ආපසු
            </button>

            <div style={{ textAlign: 'justify', marginBottom: '40px' }}>
                <h1 className="rajawaka-title">
                    රජවක නවාතැන් පහසුකම්
                </h1>
                <hr className="footer-sep" />

                <div className="rajawaka-btn-group">
                    {rooms.map(room => (
                        <button
                            key={room.id}
                            onClick={() => setActiveRoom(room.id)}
                            className="rajawaka-nav-btn"
                            style={{
                                background: activeRoom === room.id ? '#0b6b2f' : '#f3f4f6',
                                color: activeRoom === room.id ? '#fff' : '#4b5563',
                                boxShadow: activeRoom === room.id ? '0 4px 12px rgba(11, 107, 47, 0.3)' : 'none'
                            }}
                        >
                            {room.name}
                        </button>
                    ))}
                </div>
            </div>

            <div className="rajawaka-content-box">
                {activeRoom === 1 && (
                    <div className="fade-in">


                        <div className="rajawaka-btn-group" style={{ justifyContent: 'flex-start', marginBottom: '24px' }}>
                            {roomTypes.map(type => (
                                <button
                                    key={type.id}
                                    onClick={() => setActiveRoomType(type.id)}
                                    className="rajawaka-room-type-btn"
                                    style={{
                                        background: activeRoomType === type.id ? '#0b6b2f' : 'transparent',
                                        color: activeRoomType === type.id ? '#fff' : '#0b6b2f',
                                    }}
                                >
                                    {type.name}
                                </button>
                            ))}
                        </div>

                        <div style={{ background: '#f9fafb', padding: '24px', borderRadius: '8px' }}>
                            <h3 className="rajawaka-room-type-title">
                                {roomTypes.find(t => t.id === activeRoomType)?.name}
                            </h3>

                            {activeRoomType === 'A' ? (
                                <div>
                                    <p className="rajawaka-room-desc">
                                        දෙදෙනෙකු සඳහා වේ. වායුසමීකරන පහසුකම් ඇත.<br></br>
                                        (කාමරයක එක් දිනක් සදහා ගාස්තුව පහත පරිදි වේ.)
                                    </p>

                                    <div style={{ overflowX: 'auto', marginBottom: '24px' }}>
                                        <table className="rajawaka-price-table">
                                            <tbody>
                                                <tr style={{ borderBottom: '1px solid #e5e7eb' }}>
                                                    <td style={{ fontWeight: '500' }}>රජයේ නිලධාරි</td>
                                                    <td style={{ fontWeight: '600', textAlign: 'right' }}>7500.00</td>
                                                </tr>
                                                <tr style={{ borderBottom: '1px solid #e5e7eb' }}>
                                                    <td style={{ fontWeight: '500' }}>දේශීය සංචාරකයින්</td>
                                                    <td style={{ fontWeight: '600', textAlign: 'right' }}>8000.00</td>
                                                </tr>
                                                <tr>
                                                    <td style={{ fontWeight: '500' }}>විදේශිකයින්</td>
                                                    <td style={{ fontWeight: '600', textAlign: 'right' }}>10000.00</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>

                                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '16px', marginTop: '32px' }}>
                                        {[1, 2, 3, 4, 5, 6].map((imgIndex) => (
                                            <div key={`typeA-${imgIndex}`} style={{ position: 'relative' }}>
                                                <img
                                                    src={`/typeA/img0${imgIndex}.jpg`}
                                                    alt={`Type A Room View ${imgIndex}`}
                                                    style={{ width: '100%', height: '200px', objectFit: 'cover', borderRadius: '8px', border: '1px solid #e5e7eb', boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}
                                                    onError={(e) => {
                                                        console.error(`Error loading image /typeA/img0${imgIndex}.jpg`);
                                                    }}
                                                />
                                            </div>
                                        ))}
                                    </div>
                                    <p style={{ textAlign: 'center', fontSize: '14px', color: '#888', marginTop: '12px', fontStyle: 'italic' }}>(Type A කාමරයේ ඡායාරූප)</p>
                                </div>
                            ) : activeRoomType === 'B' ? (
                                <div>
                                    <p className="rajawaka-room-desc">
                                        දෙදෙනෙකු සඳහා වේ ( ඇඳන් 02 කි).<br></br>
                                        (කාමරයක එක් දිනක් සදහා ගාස්තුව පහත පරිදි වේ.)
                                    </p>

                                    <div style={{ overflowX: 'auto', marginBottom: '24px' }}>
                                        <table className="rajawaka-price-table">
                                            <tbody>
                                                <tr style={{ borderBottom: '1px solid #e5e7eb' }}>
                                                    <td style={{ fontWeight: '500' }}>රජයේ නිලධාරි</td>
                                                    <td style={{ fontWeight: '600', textAlign: 'right' }}>800.00</td>
                                                </tr>
                                                <tr style={{ borderBottom: '1px solid #e5e7eb' }}>
                                                    <td style={{ fontWeight: '500' }}>දේශීය සංචාරකයින්</td>
                                                    <td style={{ fontWeight: '600', textAlign: 'right' }}>1000.00</td>
                                                </tr>
                                                <tr>
                                                    <td style={{ fontWeight: '500' }}>විදේශිකයින්</td>
                                                    <td style={{ fontWeight: '600', textAlign: 'right' }}>1500.00</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>

                                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '16px', marginTop: '32px' }}>
                                        {[1, 2].map((imgIndex) => (
                                            <div key={`typeB-${imgIndex}`} style={{ position: 'relative' }}>
                                                {/* Placeholder for Type B images */}
                                                <img
                                                    src={`/typeB/img0${imgIndex}.jpg`}
                                                    alt={`Type B Room View ${imgIndex}`}
                                                    style={{ width: '100%', height: '200px', objectFit: 'cover', borderRadius: '8px', border: '1px solid #e5e7eb', boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}
                                                    onError={(e) => {
                                                        console.error(`Error loading image /typeB/img0${imgIndex}.jpg`);
                                                    }}
                                                />
                                            </div>
                                        ))}
                                    </div>
                                    <p style={{ textAlign: 'center', fontSize: '14px', color: '#888', marginTop: '12px', fontStyle: 'italic' }}>(Type B කාමරයේ ඡායාරූප)</p>
                                </div>
                            ) : activeRoomType === 'C' ? (
                                <div>
                                    <p className="rajawaka-room-desc">
                                        තිදෙනෙකු සදහා වේ ( ඇදන් 03 කි ).<br></br>
                                        (කාමරයක එක් දිනක් සදහා ගාස්තුව පහත පරිදි වේ.)
                                    </p>

                                    <div style={{ overflowX: 'auto', marginBottom: '24px' }}>
                                        <table className="rajawaka-price-table">
                                            <tbody>
                                                <tr style={{ borderBottom: '1px solid #e5e7eb' }}>
                                                    <td style={{ fontWeight: '500' }}>රජයේ නිලධාරි</td>
                                                    <td style={{ fontWeight: '600', textAlign: 'right' }}>1000.00</td>
                                                </tr>
                                                <tr style={{ borderBottom: '1px solid #e5e7eb' }}>
                                                    <td style={{ fontWeight: '500' }}>දේශීය සංචාරකයින්</td>
                                                    <td style={{ fontWeight: '600', textAlign: 'right' }}>1200.00</td>
                                                </tr>
                                                <tr>
                                                    <td style={{ fontWeight: '500' }}>විදේශිකයින්</td>
                                                    <td style={{ fontWeight: '600', textAlign: 'right' }}>2000.00</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>

                                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '16px', marginTop: '32px' }}>
                                        {[1, 2].map((imgIndex) => (
                                            <div key={`typeC-${imgIndex}`} style={{ position: 'relative' }}>
                                                {/* Placeholder for Type C images */}
                                                <img
                                                    src={`/typeC/img0${imgIndex}.jpg`}
                                                    alt={`Type C Room View ${imgIndex}`}
                                                    style={{ width: '100%', height: '200px', objectFit: 'cover', borderRadius: '8px', border: '1px solid #e5e7eb', boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}
                                                    onError={(e) => {
                                                        console.error(`Error loading image /typeC/img0${imgIndex}.jpg`);
                                                    }}
                                                />
                                            </div>
                                        ))}
                                    </div>
                                    <p style={{ textAlign: 'center', fontSize: '14px', color: '#888', marginTop: '12px', fontStyle: 'italic' }}>(Type C කාමරයේ ඡායාරූප)</p>
                                </div>
                            ) : activeRoomType === 'D' ? (
                                <div>
                                    <p className="rajawaka-room-desc">
                                        ( අමුත්තන් 100 ක් සදහා ඉඩ පහසුකම් ඇත)
                                    </p>

                                    <div style={{ overflowX: 'auto', marginBottom: '24px' }}>
                                        <table className="rajawaka-price-table">
                                            <tbody>
                                                <tr style={{ borderBottom: '1px solid #e5e7eb' }}>
                                                    <td style={{ fontWeight: '500' }}>AC සහිත එක් දිනක් සදහා</td>
                                                    <td style={{ fontWeight: '600', textAlign: 'right' }}>8000.00</td>
                                                </tr>
                                                <tr>
                                                    <td style={{ fontWeight: '500' }}>AC රහිතව එක් දිනක් සදහා</td>
                                                    <td style={{ fontWeight: '600', textAlign: 'right' }}>5000.00</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '16px', marginTop: '32px' }}>
                                        {[1].map((imgIndex) => (
                                            <div key={`typeD-${imgIndex}`} style={{ position: 'relative' }}>
                                                {/* Placeholder for Type D images */}
                                                <img
                                                    src={`/typeD/img0${imgIndex}.jpg`}
                                                    alt={`Type D Room View ${imgIndex}`}
                                                    style={{ width: '50%', height: '200px', objectFit: 'cover', borderRadius: '8px', border: '1px solid #e5e7eb', boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}
                                                    onError={(e) => {
                                                        console.error(`Error loading image /typeD/img0${imgIndex}.jpg`);
                                                    }}
                                                />
                                            </div>
                                        ))}
                                    </div>
                                    <p style={{ textAlign: 'center', fontSize: '14px', color: '#888', marginTop: '12px', fontStyle: 'italic' }}>(දේශන ශාලාවේ ඡායාරූප)</p>
                                </div>
                            ) : null}

                        </div>
                    </div>
                )}

                {activeRoom === 2 && (
                    <div className="fade-in">
                        <h2 style={{ color: '#0b6b2f', marginBottom: '24px', fontSize: '24px', borderBottom: '2px solid #e5e7eb', paddingBottom: '12px' }}>
                            පිහිටි ස්ථානය
                        </h2>

                        <div style={{ width: '100%', height: '300px', borderRadius: '12px', overflow: 'hidden', boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)' }}>
                            <iframe
                                src="https://www.google.com/maps?q=Agriculture+In-service+Training+Institute+Rajawaka&output=embed"
                                width="100%"
                                height="100%"
                                style={{ border: 0 }}
                                allowFullScreen=""
                                loading="lazy"
                                title="Agriculture In-service Training Institute Rajawaka Map"
                            ></iframe>
                        </div>

                        <div style={{ marginTop: '40px' }}>
                            <h3 style={{ color: '#0b6b2f', marginBottom: '20px', fontSize: '20px', fontWeight: '600' }}>
                                ආසන්න නැරඹිය හැකි ස්ථාන
                            </h3>

                            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: '20px' }}>
                                {[
                                    { name: 'දූවිලි ඇල්ල', dist: '14km', img: '01' },
                                    { name: 'දියවිනි ඇල්ල', dist: '08 km', img: '02' },
                                    { name: 'කූරගල රජමහා විහාරය', dist: '13 km', img: '03' },
                                    { name: 'බුදුගල රජමහා විහාරය', dist: '19 km', img: '04' },
                                    { name: 'සමනලවැව ජලාශය', dist: '14 km', img: '05' },
                                    { name: 'සමනලවැව විදුලි බලාගාරය', dist: '5km', img: '06' },
                                    { name: 'උඩවලව ජාතික උද්‍යානය (හදගිරිය පිවිසුම)', dist: '06km', img: '07' }
                                ].map((place, idx) => (
                                    <div key={idx} style={{
                                        background: '#fff',
                                        borderRadius: '12px',
                                        overflow: 'hidden',
                                        border: '1px solid #e5e7eb',
                                        boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
                                        transition: 'transform 0.2s ease'
                                    }}>
                                        <div style={{ height: '250px', overflow: 'hidden' }}>
                                            <img
                                                src={`/nearby/img${place.img}.jpg`}
                                                alt={place.name}
                                                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                                onError={(e) => {
                                                    e.target.src = 'https://via.placeholder.com/400x300?text=' + encodeURIComponent(place.name);
                                                }}
                                            />
                                        </div>
                                        <div style={{ padding: '12px', background: '#f0fdf4' }}>
                                            <h4 style={{ fontSize: '15px', color: '#111827', margin: '0 0 4px 0', fontWeight: '600' }}>{place.name}</h4>
                                            <p style={{ fontSize: '13px', color: '#0b6b2f', margin: 0, fontWeight: '500' }}>දුර: {place.dist}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                )}

                {activeRoom === 3 && (
                    <div className="fade-in">
                        <h2 style={{ color: '#1f2937', marginBottom: '24px', fontSize: '24px', borderBottom: '2px solid #e5e7eb', paddingBottom: '12px' }}>
                            අමතන්න
                        </h2>
                        <div style={{ display: 'grid', gap: '24px', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))' }}>
                            <div style={{ padding: '24px', background: '#f0fdf4', borderRadius: '8px', border: '1px solid #bbf7d0' }}>
                                <h3 style={{ color: '#166534', marginBottom: '12px', fontSize: '20px' }}>සහකාර කෘෂිකර්ම අධ්‍යක්ෂ (එස්.එම්.සී.පී. සිරිවර්ධන මයා)</h3>
                                <p style={{ fontSize: '24px', fontWeight: 'bold', color: '#15803d' }}>071-8144730</p>
                            </div>
                            <div style={{ padding: '24px', background: '#eff6ff', borderRadius: '8px', border: '1px solid #bfdbfe' }}>
                                <h3 style={{ color: '#1e40af', marginBottom: '12px', fontSize: '20px' }}>ගොවිපල් කලමණාකරු (චන්දිම බණ්ඩාර මයා)</h3>
                                <p style={{ fontSize: '24px', fontWeight: 'bold', color: '#1d4ed8' }}>077-8002913</p>
                            </div>
                        </div>
                    </div>
                )}

                {activeRoom === 4 && (
                    <div className="fade-in">
                        <h2 style={{ color: '#0b6b2f', marginBottom: '24px', fontSize: '24px', borderBottom: '2px solid #e5e7eb', paddingBottom: '12px' }}>
                            ඡායාරූප එකතුව (Gallery)
                        </h2>
                        <div style={{
                            display: 'grid',
                            gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
                            gap: '20px',
                            padding: '10px 0'
                        }}>
                            {Array.from({ length: 120 }, (_, i) => i + 1).map((num) => {
                                const imgName = `img${num.toString().padStart(2, '0')}.jpg`;
                                return (
                                    <div
                                        key={num}
                                        className="gallery-item"
                                        style={{
                                            borderRadius: '12px',
                                            overflow: 'hidden',
                                            boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                                            height: '220px',
                                            backgroundColor: '#f3f4f6',
                                            transition: 'transform 0.3s ease'
                                        }}
                                    >
                                        <img
                                            src={`/RajawakaG/${imgName}`}
                                            alt={`Gallery item ${num}`}
                                            style={{
                                                width: '100%',
                                                height: '100%',
                                                objectFit: 'cover',
                                                cursor: 'pointer'
                                            }}
                                            onError={(e) => {
                                                e.target.parentElement.style.display = 'none';
                                            }}
                                            onClick={(e) => {
                                                // Simple zoom effect simulation for premium feel
                                                e.target.style.transform = e.target.style.transform === 'scale(1.1)' ? 'scale(1)' : 'scale(1.1)';
                                                e.target.style.transition = 'transform 0.3s ease';
                                            }}
                                        />
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                )}
            </div>
        </div >
    );
}

export default Rajawaka;
